import NoRouteMatched from './noRouteMatched';
import PrivateRoute from './privateRoute';
import ActiveRoute from './activeRoute';
import Route from './simpeRoute';
import Link from './link';
import Prompt from './prompt';

export {
    NoRouteMatched,
    PrivateRoute,
    ActiveRoute,
    Route,
    Link,
    Prompt
};
